import { trackEngagement } from "helpers/analytics";

export const onForwardingLinkClick = (): void => {
  trackEngagement("Mailboxes: Gmail forwarding link clicked");
};

export const onHelpCenterLinkClick = (): void => {
  trackEngagement("Mailboxes: Help Center link clicked");
};

export const onYahooLinkClick = (): void => {
  trackEngagement("Mailboxes: Yahoo link clicked");
};

export const onOutlookLinkClick = (): void => {
  trackEngagement("Mailboxes: Outlook link clicked");
};

export const onOfficeLinkClick = (): void => {
  trackEngagement("Mailboxes: Office 365 link clicked");
};
